import React, { useEffect } from 'react';
import PricingTable from '@/components/PricingTable';

const Pricing = () => {
  // Set page title
  useEffect(() => {
    document.title = "Pricing - up247";
  }, []);

  return (
    <>
      <PricingTable />
    </>
  );
};

export default Pricing;
